import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  eligibilityLogsList: [],
  loading: false,
  eligibilityReportList: [],
  devices: [],
  patients: [],
  dropDownLoading: false,
}

export default factoryReducer(initialState, actions)
